<template>
  <div class="news-info">
    <div class="title wow slideInDown">新闻公告</div>
    <div class="info-container">
      <div class="top-info wow fadeInLeft">
        <div class="img-box">
          <img class="img" src="@/assets/news-img1.jpg" alt="" />
        </div>
        <div class="list-box">
          <div class="info" v-for="item in newList1" :key="item.id">
            <div class="detail">
              <div class="info-title" :title="item.title"><router-link :target="isMobile?'_self':'_blank'" class="link" :to="{path:'/newsDetail', query:{id: item.id}}">{{ item.title }}</router-link></div>
              <div class="date">
                <div class="day">{{item.time | dateFormat('MM-dd')}}</div>
                <div class="year">{{item.time | dateFormat('yyyy')}}</div>
              </div>
            </div>
            <div class="desc" :title="item.des">
              {{ item.des | wordLimit(85) }}
            </div>
            <div class="dateBottom">
              <div class="dateBottom-time">{{item.time | dateFormat('yyyy')}}-{{item.time | dateFormat('MM-dd')}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-info  wow fadeInRight">
        <div class="list-box">
          <div class="info" v-for="item in newList2" :key="item.id">
            <div class="detail">
              <div class="info-title" :title="item.title"><router-link :target="isMobile?'_self':'_blank'" class="link" :to="{path:'/newsDetail', query:{id: item.id}}">{{ item.title }}</router-link></div>
              <div class="date">
                <div class="day">{{item.time | dateFormat('MM-dd')}}</div>
                <div class="year">{{item.time | dateFormat('yyyy')}}</div>
              </div>
            </div>
            <div class="desc" :title="item.des">
              {{ item.des | wordLimit(85) }}
            </div>
            <div class="dateBottom">
              <div class="dateBottom-time">{{item.time | dateFormat('yyyy')}}-{{item.time | dateFormat('MM-dd')}}</div>
            </div>
          </div>
        </div>
        <div class="img-box">
          <img class="img" src="@/assets/news-img2.jpg" alt="" />
        </div>
      </div>
    </div>
<!--    <div class="more">more</div>-->
    <router-link :to="{path: '/newsList', query: {type: 'news', name: '新闻公告'}}" :target="isMobile?'_self':'_blank'" class="more">MORE</router-link>
  </div>
</template>

<script>
export default {
  props: ['news'],
  computed: {
    isMobile () {
      return /Android|Windows Phone|iPhone|iPod/i.test(navigator.userAgent)
    }
  },
  data () {
    return {
      newList1: [],
      newList2: []
    }
  },
  watch: {
    news (n, o) {
      this.newsInfo = n[0]
      if (this.newsInfo?.dictCode) {
        this.getInfo([this.newsInfo.dictCode])
      }
    }
  },
  methods: {
    getInfo (typeCode) {
      this.$axios.post(process.env.VUE_APP_jiaxingUrl + '/system/open/getTextListByPage', { pageNum: 1, pageSize: 4, typeCode }).then(res => {
        const data = res.data
        this.newList1 = data.rows.filter((item, index) => index < 2)
        this.newList2 = data.rows.filter((item, index) => index > 1 && index < 4)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.news-info {
  width: 1200px;
  margin: 0 auto;
  .title {
    position: relative;
    height: 40px;
    line-height: 40px;
    font-size: 40px;
    font-weight: 600;
    color: #4370ca;
    font-family: MicrosoftYaHei-Bold;
    text-align: center;
    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: -24px;
      width: 80px;
      height: 4px;
      background-color: #4370ca;
      transform: translateX(-50%);
    }
  }
  .info-container {
    margin-top: 98px;
    height: 672px;
    .top-info,
    .bottom-info {
      display: flex;
      justify-content: space-between;
      height: 318px;
    }
    .top-info {
      margin-bottom: 36px;
    }
    .img-box {
      width: 486;
      height: 318;
      border-radius: 0 20px 0 20px;
      overflow: hidden;
      .img {
        height: 100%;
        width: 100%;
        transition: all 1s;
        &:hover {
          transform: scale(1.2);
        }
      }
    }
    .list-box {
      width: 694px;
      height: 316px;
      .info {
        position: relative;
        width: 100%;
        height: 151px;
        padding: 20px 20px 0 0;
        box-shadow: 0px 7px 23px 1px rgba(0, 0, 0, 0.08);
        border-radius: 0px 20px 0px 20px;
        overflow: hidden;
        & + .info {
          margin-top: 16px;
        }
        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 6px;
          background: #4370ca;
          border-radius: 0px 0 0px 20px;
        }
      }
      .detail {
        display: flex;
        height: 38px;
        .link {
          color: #333;
          text-decoration: none;
        }
        .info-title {
          height: 38px;
          width: calc(100% - 82px);
          padding: 0 20px 0 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 38px;
          color: #333;
          font-size: 16px;
          font-weight: 600;
        }
        .date {
          width: 82px;
          text-align: right;
          color: #cdcdcd;
          .day {
            line-height: 30px;
            font-size: 30px;
          }
          .year {
            font-size: 12px;
          }
        }
      }
      .desc {
        margin-top: 22px;
        padding-left: 10px;
        line-height: 22px;
        color: #929292;
        font-size: 14px;
      }
      .dateBottom{
        display: none;
      }
    }
  }
  .more{
    display: none;
  }
}
</style>
